import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "How a $12 AWS bill powers a $50k business",
  "description": "my point is that running server code on the web has become ridiculously cheap *and* easy",
  "published": "2021-03-09T00:00:00.000Z",
  "categories": "Serverless, Technical",
  "content_upgrade": "ServerlessHandbook",
  "hero": "./img/screenshot-1615309454713.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Friend, ever seen this meme about the bloat of VC-backed startups?`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "751px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f52f9d685f88832e6e08968d3004d26d/6122b/SzYypgjpgchiaa3.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M6%2036c0%202%200%202%202%202%204-2%205%200%205%2010%200%207%200%209%202%209l1-9c0-10%200-11%205-11%201%201%202%200%202-1s-1-2-9-2c-7%200-8%200-8%202m19-1c-1%203%200%2021%202%2022l1-4c0-6%201-9%203-10%203-1%204%201%204%208%200%204%201%206%202%206s2-2%202-7c0-8-2-11-8-10-3%201-3%201-3-2%200-4-2-5-3-3m20%206c-5%202-5%2012%200%2015%204%202%2011%200%2011-4%200-2-3-1-4%201s-7%201-7-1%202-3%207-3c4%200%204%200%204-2%200-5-6-8-11-6m39%201c-4%205-1%2015%205%2015%207%200%2011-9%206-14-4-4-7-4-11-1m19-1c-4%201-5%2010-3%2013s8%204%2011%201c7-6%201-18-8-14m40%201c-3%203-2%206%204%208%205%201%205%203%201%204l-4-1c0-2-3-3-3-1%200%203%203%205%207%205%207%200%208-7%201-10-5-2-6-3-2-4l3%201%202%201c2%200%201-3-1-4-3-2-6-1-8%201m22-1c-1%204%200%2022%202%2022l2-2v-3c0-1%201-2%203-1%203%200%206-2%207-5%202-7-3-14-8-11h-6m30%200c-4%202-4%2012%200%2015%206%204%2014-3%2011-11-2-4-6-6-11-4m40%200c-5%202-4%206%203%209l4%203c0%202-6%201-7-1h-2c-2%202%202%205%206%205%207%200%208-7%201-10-5-2-6-3-2-4l3%201%202%201c3%200%203-2%200-3-3-2-4-2-8-1M3%2094c-3%201-3%201-1%201s2%200%201%201v3c1%202%202%204%201%205l1%204%202%209a390%20390%200%20001%2014l-2%204c0%202-1%203-3%203H1L0%20259v121h189v-10c0-8-1-11-2-11h-3c-2%200-10-4-11-6l-1-2c-2%200-2-7%200-8l13-1h2c2%200%202-1%202-14l-1-14-2-1h-1c0%202%200%202-4%200-10-5-11-14-2-11h6l2%201c2%200%202-1%202-13v-13h-4c-5%200-10-2-11-6-1-3%200-5%205-4h7l3%201v-9h-6c-10%200-11-1-8-9%201-4%202-5%205-5h8c1%201%201-1%201-8%200-10%200-10-3-11-2%200-2-1-2-6l1-6c2%200%201-3-1-3h-2v2c2%200%202%200%201%201l-1%205c0%206-2%208-5%206v-37c0-3%200-3%205-3%204%200%205%200%206%202%201%204%202-4%202-14v-8l-5-1c-6%200-8-1-6-4l5-1c6%200%206-2%200-2-3%200-5-1-5-2l5-1c4%201%205%200%205-1l-4-1-5-1c-2-1-2-2%203-2%207-1%209-2%204-4l-3-1%203-1c2%200%203-1%203-6%200-6%200-6-3-6l-3-2-1-2c-1-1%200-1%203-1%204-1%204-1%204-5%200-3%200-4%201-3l9%201h9c2-2%201-6-1-7s-2-3%203-9l4-6%201-1h2l6-2-4-1h-28v5c0%2015-1%2018-4%2016s-3-3%200-3c3-1%203-10%200-12v-2l2-3c0-2-1-2-31-2l-32%201c-2%200-3%202-3%2010a255%20255%200%2001-6%2048c-1%204-2%205-4%204-2%200-2%200-2%202%200%203%200%203-5%203h-5v-4c0-3%200-4-2-4s-2%201-2%204c0%204%200%204-3%204-4%200-4%200-4-4l-1-4-2%201-4%201-5-1-4-1h-3l2-2c2-2%202-2%201-3l-3%201c-1%201-1%201-3-1s-2-2-1-3v-2h-2c-1%202-2%201-5-2-4-3-5-4-5-2h-1v-2c1-1%201-1-2-2-5-1-6-1-4-2%202%200%202-1%201-1h-3c-1-1-1%200-1%202%200%205-2%205-2-1%200-3%200-4-1-2l-1%202-1-2-1-5-1-4-1-5-5-7c-3-3-4-5-3-5l1-1h-1l-2%201%203-8v-1c-2%201-2%201-1-1v-2l-1%201h-1c-2-2-22-1-25%201m305-1l-4%208c-2%206-3%207-6%208l-3%201-1%2020c0%2024%200%2023-9%2029l-9%207c-2%202-5%205-7%205-4%201-7%205-7%2010l-2%204c-3%200-2%202%201%203%205%201%206%204%206%2017l2%2013c1%202%202%200%202-5%200-3%200-5%201-4l3%203%203%201%203-5c2-5%206-8%2011-10%203%200%203%200%203%207l1%2056-4-1a796%20796%200%2000-56-31%20817%20817%200%2000-44-23c-2%201%200%205%204%207l4%202%204%203%204%203%209%206%208%205%205%203c2%200%203%202%201%202-3%200%201%202%207%203%206%202%2012%205%2015%208l3%201%204%202%207%204%206%202%2019%2011%2011%207%209%206%208%205c6%203%209%205%209%207l5%203c5%201%207%203%206%204%200%201%205%203%207%202v1c-1%201-1%201%201%201s5%202%204%204l1%201%201-1%202-1%201%203c-1%201%200%201%202%202%204%200%206%202%205%203l2%202%203%201%205%202%206%202%203%202%209%205%202%201%203%202c2%202%203%201%203-6v-6l-6-4a775%20775%200%2000-24-13v-86l1-21%202-1c2%200%2017%203%2023%206l4%201v-34c0-38%201-35-8-38l-11-2c-5%200-5%200-8-2-2-3-2-4-2-18l1-15-13-1-19%201h-32M67%20181v8c0%203%202%206%204%204h10v-5c0-4-1-5-4-5-4%200-5%200-4%204l-1%201v2h-1v-4c1-2%200-3-1-5l-2-2-1%202m22%201l-3%201h-3v5c0%207%202%208%202%202%200-3%201-4%202-4%202-1%202-1%202%202%200%205%202%207%205%205h7c3%200%204%200%204%202-1%202%201%203%202%200%201-2%204-2%205-1h1v-2h9c1-2%200-5-3-5l-2-1%202-1c4%201%204-1%201-2-2-1-3%200-5%201s-3%201-2-2h-2c1-1%200-2-1-2l-1%202-2%201c-3%200-3%200-3%205l-1%205v-6c0-6-2-7-3-1%200%204-2%206-3%204-1-1-1-1%201-1v-1l-1-3-2-2-3-1-1-2-2%202m268%20181l-6%203-4%202c-3-1-3-1-3%203l-1%205c-2%201-1%202%202%201%201%200%202-1%201-2l3-1c3%200%204%202%201%202-1%201%203%201%208%201h10v-5l-1-6v-3h-10\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f52f9d685f88832e6e08968d3004d26d/ca0a1/SzYypgjpgchiaa3.webp 223w", "/static/f52f9d685f88832e6e08968d3004d26d/75680/SzYypgjpgchiaa3.webp 445w", "/static/f52f9d685f88832e6e08968d3004d26d/0d6a7/SzYypgjpgchiaa3.webp 751w"],
              "sizes": "(max-width: 751px) 100vw, 751px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f52f9d685f88832e6e08968d3004d26d/853b2/SzYypgjpgchiaa3.jpg 223w", "/static/f52f9d685f88832e6e08968d3004d26d/0a4fe/SzYypgjpgchiaa3.jpg 445w", "/static/f52f9d685f88832e6e08968d3004d26d/6122b/SzYypgjpgchiaa3.jpg 751w"],
              "sizes": "(max-width: 751px) 100vw, 751px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/f52f9d685f88832e6e08968d3004d26d/6122b/SzYypgjpgchiaa3.jpg",
              "alt": "SzYypgjpgchiaa3",
              "title": "SzYypgjpgchiaa3",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`It's a running joke in the industry. Startup gets funded, startup shovels money into the AWS furnace, Bezos gets rich.`}</p>
    <p>{`Graybeard sysadmins chuckle.`}</p>
    <p><em parentName="p">{`"Lulz only five bazillion users?? I could run that from my PC in the basement. These people ... `}{`<`}{`eyeroll>"`}</em></p>
    <p>{`We'll talk about that on Friday. Today I wanted to talk about `}<em parentName="p">{`my`}</em>{` AWS bill. A whopping $12 per month. 😛`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Oh no my AWS bill is up to $12/mo 😱 how will I ever afford this with the $50k/yr business it supports`}<br parentName="p"></br><br parentName="p"></br>{`stop looking for free, use what works`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1367503207803609090"
      }}>{`March 4, 2021`}</a></blockquote>
    <h2 {...{
      "id": "serverless-cost-optimization"
    }}>{`Serverless cost optimization`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Value your time`}</p>
    </blockquote>
    <p>{`That's what an AWS billing expert had to say about optimizing for cost. If your bill is less than $10k/mo, it's not worth optimizing.`}</p>
    <p>{`🤯`}</p>
    <p>{`He's right. How much is your time worth? What about your focus?`}</p>
    <p>{`Would you rather build your project, launch-and-forget, then get back to work ... ooooor spend 20 minutes every other week because your server's down again? I'm sure `}<em parentName="p">{`you`}</em>{` like to fret every moment of every day about the alarm that says `}<em parentName="p">{`"Shit's on fire, user can't do the thing"`}</em></p>
    <ContentUpgrades.ServerlessHandbook />
    <p>{`That's advanced for a side-project. Usually it's a user that complains on twitter. You had no idea your app's been down for 3 days 😅`}</p>
    <h2 {...{
      "id": "problems--solved"
    }}>{`Problems 👉 solved`}</h2>
    <p>{`I like the launch-and-forget approach.`}</p>
    <p><inlineCode parentName="p">{`yarn deploy`}</inlineCode>{`, wait 3 minutes, ✅`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/LOcPt9gfuNOSI/giphy-loop.mp4?cid=7cf28b0foz30gk25v70lvkb3t5yr6q755kbt103daghpv7h5&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Here's what my $12 AWS bill solves:`}</p>
    <ul>
      <li parentName="ul">{`enabling purchases`}</li>
      <li parentName="ul">{`layouting emails`}</li>
      <li parentName="ul">{`reader feedback`}</li>
    </ul>
    <p>{`Set them up, never thought about it again. It just works.`}</p>
    <h3 {...{
      "id": "gumroad-hook"
    }}>{`Gumroad hook`}</h3>
    <p>{`You can do a lot with Zapier integrations, a no-code glue platform, but you can't connect your payments provider to your custom platform.`}</p>
    <p>{`For that you need `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/a-javascript-function-that-makes-dollar40000+year"
      }}>{`the most impactful JavaScript function I ever wrote`}</a>{`. It creates a new user for every purchase.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/0bc2a938d941e16de162975b82c558dc/5a190/Sketch-of-how-the-Gumroad-hook-works077gb0.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "73.54260089686098%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'294\\'%20viewBox=\\'0%200%20400%20294\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M222%2037c-8%201-22%208-28%2011-7%205-14%2017-16%2027l-1%205h-4c-18%201-43%206-43%208l10-2c9-3%2024-5%2033-5h4v7c0%2026%2017%2047%2037%2047%2014%200%2033-13%2048-34l8-8v-3c1-1%2014-3%2029-4%2013-1%2015-1%2014-2a257%20257%200%2000-42%204l2-5%202-4%2013-3c18-3%2018-3%2014%201-4%202-5%204-3%204l2-2%208-5c10-5%209-6-6-6-6%200-9%200-8%201l9%201%209%201-4%201-18%202-15%203-1-9c0-6-1-9-2-10-17-20-32-26-51-21m7%201l-7%202-6%201%205%202c4%201%207%205%203%204-9-1-17-1-20%201l-5%202c-4%200-11%208-15%2018l-3%206%207%202c14%204%2013%209-2%2011l-5%201-1%204c0%209%205%2023%2013%2031%2015%2016%2036%2012%2058-11%207-8%2015-19%2014-20l-15%201-1-1%204-3%205-4h4l-3%202-3%202h4c6%200%208-1%2010-6l1-4c-1%200-19%203-23%205h-5l21-6c7%200%208-1%208-7%200-8-4-13-8-9-2%201-2%201-2-1s0-2%203-2c5%201%205-1%200-6-4-5-12-10-18-12-4-2-17-3-18-3m-80%2029l-1%203c0%202%200%202%202%201%201-2%201-2%201%200%200%204%206%207%2010%206%202-1%203-2%201-5v-2l1-1c0-1-5-2-8-1h-4l-2-1m-38%2014a1111%201111%200%2001-91%203l-3%206-1%207c-1%203%200%203%2018%202a562%20562%200%20010-2l-16%201%201-4c1-9-1-8%2028-10l46-1%2019%201v8c0%2010%202%2011%202%201s-1-14-3-12m235%203c-2%203-2%209%200%206h22l-3-1h-2l2-2c3-3%203-4-1-2h-3c-2-2-6-1-6%201-1%203-4%203-4%200-1-3-3-4-5-2M24%20105c-3%200-4%201-4%202l-2%206c-2%207-1%209%205%207%2010-4%2033-6%2033-3l1%201%201-4v-5c3-1%200-2-6-3l-10-1H24m1%202c-3%200-4%201-5%206-2%206-1%206%203%205%204-2%2015-4%2024-5%207%200%2011-2%209-4s-25-3-31-2m40%200v5c-1%205-1%206%202%206a938%20938%200%200126-2c-4%200-4%200-3-2%202-7%202-7-13-7H65m2%203v3c0%202%201%203%2010%203h10l1-3%201-4c0-1-21-1-22%201m-31%2011h-3c-2%201-3%201-3%207%200%208%200%208%2011%209l15%203c7%202%2021%201%2022-1v-12c-2-3-2-4-7-5s-32-2-35-1m-4%207c-1%206-1%206%2012%208l12%202h20l1-6c-1-8-1-8-24-9H33l-1%205m127%2055l-2%2013%2017%203c2-1%203-13%202-14l-5-2h-12m1%203l-1%205v4l7%201%207%201v-12c-5-1-12-1-13%201m52%2023l-22%201c-16%200-21%201-18%202%202%202%200%2028-2%2030a358%20358%200%200148-5h11v2l1%203%201-3%201-3v-8c1-5-1-16-3-18-1-1-10-2-17-1m-6%202l-19%201-12%201a635%20635%200%2000-1%2024l-1%204h3a440%20440%200%200153-6l1-7c1-6-1-15-3-17h-21\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0bc2a938d941e16de162975b82c558dc/ca0a1/Sketch-of-how-the-Gumroad-hook-works077gb0.webp 223w", "/static/0bc2a938d941e16de162975b82c558dc/75680/Sketch-of-how-the-Gumroad-hook-works077gb0.webp 445w", "/static/0bc2a938d941e16de162975b82c558dc/d00b9/Sketch-of-how-the-Gumroad-hook-works077gb0.webp 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0bc2a938d941e16de162975b82c558dc/e92b6/Sketch-of-how-the-Gumroad-hook-works077gb0.png 223w", "/static/0bc2a938d941e16de162975b82c558dc/e66bf/Sketch-of-how-the-Gumroad-hook-works077gb0.png 445w", "/static/0bc2a938d941e16de162975b82c558dc/5a190/Sketch-of-how-the-Gumroad-hook-works077gb0.png 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0bc2a938d941e16de162975b82c558dc/5a190/Sketch-of-how-the-Gumroad-hook-works077gb0.png",
                "alt": "Sketch of how the Gumroad hook works",
                "title": "Sketch of how the Gumroad hook works",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Sketch of how the Gumroad hook works`}</figcaption>{`
  `}</figure></p>
    <p>{`Here's what it does:`}</p>
    <ol>
      <li parentName="ol">{`User makes a purchase`}</li>
      <li parentName="ol">{`Gumroad sends POST request to a URL`}</li>
      <li parentName="ol">{`AWS Gateway routes the request`}</li>
      <li parentName="ol">{`AWS Lambda wakes up a new server`}</li>
      <li parentName="ol">{`Server runs 20 lines of JavaScript`}</li>
      <li parentName="ol">{`Calls API on Auth0`}</li>
      <li parentName="ol">{`Creates user, if needed`}</li>
      <li parentName="ol">{`Gives permission to access purchased course`}</li>
    </ol>
    <p>{`Took 2 hours to build, never had an outage. Processed ~$50k in revenue, touched only to add new products ✌️`}</p>
    <h3 {...{
      "id": "newsletter-layouting"
    }}>{`Newsletter layouting`}</h3>
    <p>{`As impactful as that was, it's not my favorite. My favorite is `}<a parentName="p" {...{
        "href": "https://techletter.app"
      }}>{`the newsletter layouting tool`}</a>{` that builds these emails.`}</p>
    <p>{`I love markdown. Email software hates markdown. Email clients hate embeds.`}</p>
    <p>{`What do you do? Hire an editor for $500/mo. $6000/year right there. For years.`}</p>
    <p>{`I loved my editor and he hated this part of his gig.`}</p>
    <p>{`Get a text file from Swiz, take a bunch of images, upload to Imgur, put into ConvertKit and into Wordpress. Hit 3 buttons. 🤮`}</p>
    <p>{`So I replaced him with a $1/year piece of JavaScript and he got a more rewarding job at a big company.`}</p>
    <p><img parentName="p" {...{
        "src": "/26e495001d5d80e509efa11d5b2d32e9/TechLetter-app-being-wonderfulh0djie.gif",
        "alt": "TechLetter app being wonderful"
      }}></img></p>
    <p>{`A tool that eats Markdown, converts embeds into screenshots, uploads to S3, searches Giphy for gifs, creates HTML.`}</p>
    <p>{`All powered by a `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lambda-screenshot-as-a-service"
      }}>{`screenshot lambda`}</a>{` that admittedly took lots of tinkering and updates. It even creates thumbnails for my blog 😁`}</p>
    <p>{`But you can throw `}<em parentName="p">{`anything`}</em>{` at it!`}</p>
    <p>{`Up to 1000 embeds in parallel, all good. Embed breaks the code? No worries, running on a separate server from all others. Chrome hangs? Pfft, start a new one!`}</p>
    <p>{`Resilience managed by AWS Lambda. I never need to think about it 😇`}</p>
    <h3 {...{
      "id": "reader-feedback"
    }}>{`Reader feedback`}</h3>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "742px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f6285d0468dab264feefb09c5107bf66/0f2bc/Spark-Joy-widgetsfic4fd.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.6322869955157%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'135\\'%20viewBox=\\'0%200%20400%20135\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M38%2034v9h6c7%200%2010-3%2010-10%200-6-3-9-10-9h-6v10m35-7c0%203%200%203-3%202-3%200-4%200-5%202-4%205-1%2014%204%2013l5-1h3v-9c0-8-1-10-2-10-2%200-2%201-2%203m151-2l-1%209c0%208%200%209%202%209s2-1%202-4c0-5%202-8%204-7l1%206c0%204%200%205%202%205s2-1%202-6c0-7-1-9-6-8-3%201-3%201-3-2s-2-4-3-2M86%2030l2%208c2%206%202%206%201%208-2%201-2%203%200%203%203%200%205-3%207-11%204-9%204-9%201-9-1%200-2%201-3%205l-1%205-2-5c-1-4-2-5-3-5l-2%201m16%201c-2%203-2%209%201%2011%206%205%2015-2%2011-9-2-5-8-5-12-2m15%204c0%206%201%208%204%208h9v-7c0-6%200-7-2-7s-2%201-2%204c0%205-1%208-3%207s-2-2-2-6%200-5-2-5-2%201-2%206m24-4c-5%207%202%2016%209%2011%203-2%202-3-2-3l-5-1%204-1c5%200%205%200%205-2%200-6-8-8-11-4m14-1l-1%207c0%205%200%206%202%206s2-1%202-4c0-5%202-8%204-7l1%206c0%204%200%205%202%205s2-1%202-6l-1-7h-11m24%201c-2%202-3%208-1%2010%204%205%2013%202%2013-5%200-6-8-10-12-5m13-1l3%207c2%207%202%207%201%208-3%201-2%204%200%204%203%200%204-2%207-11l3-9h-2c-2%200-3%202-3%204-2%205-2%205-4%200l-3-4-2%201m56%200l-2%204c0%202%200%202%207%205l1%201-5-1c-3-1-3-1-3%201%201%203%205%205%209%203%204-1%204-6%201-8l-2-1h2c2%200%203-2%201-4h-9m21%201c-5%207%202%2016%209%2012%203-3%203-4-2-4l-5-1%204-1c5%200%205%200%205-2%200-6-8-8-11-4m13%205c0%206%200%207%202%207s2-1%202-4c0-4%202-8%203-6l1%205c0%204%200%205%202%205s2-1%202-4c0-4%202-8%203-6l1%205c0%204%200%205%202%205s2-1%202-6l-1-7h-8l-6-1h-5v7m24-6l-1%203h7c1%201%200%201-3%202l-4%203c-1%203%202%206%205%205h8l-1-6-1-7h-10\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f6285d0468dab264feefb09c5107bf66/ca0a1/Spark-Joy-widgetsfic4fd.webp 223w", "/static/f6285d0468dab264feefb09c5107bf66/75680/Spark-Joy-widgetsfic4fd.webp 445w", "/static/f6285d0468dab264feefb09c5107bf66/28367/Spark-Joy-widgetsfic4fd.webp 742w"],
                "sizes": "(max-width: 742px) 100vw, 742px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f6285d0468dab264feefb09c5107bf66/e92b6/Spark-Joy-widgetsfic4fd.png 223w", "/static/f6285d0468dab264feefb09c5107bf66/e66bf/Spark-Joy-widgetsfic4fd.png 445w", "/static/f6285d0468dab264feefb09c5107bf66/0f2bc/Spark-Joy-widgetsfic4fd.png 742w"],
                "sizes": "(max-width: 742px) 100vw, 742px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f6285d0468dab264feefb09c5107bf66/0f2bc/Spark-Joy-widgetsfic4fd.png",
                "alt": "Spark Joy widgets",
                "title": "Spark Joy widgets",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Spark Joy widgets`}</figcaption>{`
  `}</figure></p>
    <p>{`You'll see these under every email, article, and course chapter I create. There's a few variations and they all lead to the same place 👉 a serverless GraphQL API.`}</p>
    <p>{`The API wakes up a smol server, saves your feedback to a DynamoDB table, and says thanks.`}</p>
    <p>{`Best thing I ever did for my business. So many thoughtful comments 😍`}</p>
    <p>{`One of these days I'll rebuild the frontend to look nicer, but the serverless backend is rock solid. Bit of Apollo, dash of custom code, and voila.`}</p>
    <h2 {...{
      "id": "you-can-do-this"
    }}><em parentName="h2">{`You`}</em>{` can do this`}</h2>
    <p>{`Friend, my point is that running server code on the web has become ridiculously cheap `}<em parentName="p">{`and`}</em>{` easy.`}</p>
    <p>{`My $12 bill runs all of the above, the biggest cost is serving images from S3 – $5 for hosting, $3 for bandwidth. The smarts running on AWS Lambda are `}<em parentName="p">{`way`}</em>{` below the free tier.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/beadccc6c9ed0eb687230d2b0c21db49/18d85/Lambda-is-freedf7cb4.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "24.2152466367713%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'97\\'%20viewBox=\\'0%200%20400%2097\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M60%2016c0%202%202%204%203%202h1l1%201%202-1h1c0%203%205%203%207%200h1l4%201%203%201%201%201%201-3-1-3H61c-1-1-1-1-1%201m6%2013c0%202%201%202%204%202l4-1h3c0%201%204%202%205%201h11c2%201%207%201%2010-1l1-1-2-1c-1-3-4-2-4%200h-1l-2-2v4l-1-2h-8c0-2%200-2-2-1h-9c-4%200-5%201-5%202%200%202-3%201-3-1-1-2-1-2-1%201M40%2089c0%202%200%203%205%203l6-1h1l2%201%204%201h2l4-1%203-3-6-1-7%201h-1l-4-1h-7l-1-1-1%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/beadccc6c9ed0eb687230d2b0c21db49/ca0a1/Lambda-is-freedf7cb4.webp 223w", "/static/beadccc6c9ed0eb687230d2b0c21db49/75680/Lambda-is-freedf7cb4.webp 445w", "/static/beadccc6c9ed0eb687230d2b0c21db49/8d1ba/Lambda-is-freedf7cb4.webp 890w", "/static/beadccc6c9ed0eb687230d2b0c21db49/3838e/Lambda-is-freedf7cb4.webp 1335w", "/static/beadccc6c9ed0eb687230d2b0c21db49/e11e5/Lambda-is-freedf7cb4.webp 1780w", "/static/beadccc6c9ed0eb687230d2b0c21db49/9ff84/Lambda-is-freedf7cb4.webp 2382w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/beadccc6c9ed0eb687230d2b0c21db49/e92b6/Lambda-is-freedf7cb4.png 223w", "/static/beadccc6c9ed0eb687230d2b0c21db49/e66bf/Lambda-is-freedf7cb4.png 445w", "/static/beadccc6c9ed0eb687230d2b0c21db49/4ef49/Lambda-is-freedf7cb4.png 890w", "/static/beadccc6c9ed0eb687230d2b0c21db49/4e814/Lambda-is-freedf7cb4.png 1335w", "/static/beadccc6c9ed0eb687230d2b0c21db49/701e9/Lambda-is-freedf7cb4.png 1780w", "/static/beadccc6c9ed0eb687230d2b0c21db49/18d85/Lambda-is-freedf7cb4.png 2382w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/beadccc6c9ed0eb687230d2b0c21db49/4ef49/Lambda-is-freedf7cb4.png",
                "alt": "Lambda is free",
                "title": "Lambda is free",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Lambda is free`}</figcaption>{`
  `}</figure></p>
    <p>{`18,000 requests per month is pretty cool 🚀`}</p>
    <p>{`To be fair, I offload frontend web traffic to Netlify and Vercel. A whopping $25/mo ...`}</p>
    <p>{`What do you think, got a problem you could solve with a small JavaScript function running in the cloud? Hit reply`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: yes you could run all this from your basement for free, but it's no worth your time 😉`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      